<script setup lang="ts">
import { computed, ref } from "vue"
import ImportTarget from "@/components/ListImport/ImportTarget.vue"
import LocateList from "@/components/ListImport/Locate/LocateList.vue"
import LocateTable from "@/components/ListImport/Locate/LocateTable.vue"
import { useListImportStore } from "@/stores"

const listImportStore = useListImportStore()

const scrapedFile = computed(() => listImportStore.file?.scraped)
const alphabetHeaders = computed(() => scrapedFile.value?.sheetHeaders ?? [])

const selectedTableHeader = ref<number>()

const locateItems = computed<{ id: number; label: string }[]>(() =>
  (scrapedFile.value?.headers ?? []).map((v, k) => ({
    id: k,
    label: `${alphabetHeaders.value[k]} - ${v}`,
  }))
)

function setSelectedTableHeader(value: number) {
  selectedTableHeader.value = value
  listImportStore.populateMatchDataFromLocate()
}

function clearSelectedTableHeader() {
  selectedTableHeader.value = undefined
  listImportStore.populateMatchDataFromLocate()
}

function setTarget(target: string | undefined) {
  if (target === undefined) {
    return
  }
  listImportStore.setTarget(target)
}
</script>

<template>
  <div class="flex h-full flex-1 flex-col gap-6 overflow-auto">
    <div class="sticky left-0 flex flex-col gap-4">
      <div class="flex">
        <div class="w-1/6 rounded-lg bg-gray-100 p-4">
          <ImportTarget
            :import-targets="listImportStore.importTargets"
            :model-value="listImportStore.target"
            @update:model-value="setTarget"
          />
        </div>
        <div
          class="flex flex-1 flex-wrap items-end gap-4 rounded-lg bg-gray-100 p-4"
        >
          <LocateList
            :target="listImportStore.target"
            :locate-items="locateItems"
            :locate-info="listImportStore.locateInfo"
            :selected-table-header="selectedTableHeader"
            @clear-selected-table-header="clearSelectedTableHeader"
            @update:selected-table-header="setSelectedTableHeader"
          />
        </div>
      </div>
    </div>

    <div class="size-full flex-1">
      <LocateTable
        v-if="listImportStore.file?.scraped"
        :table="listImportStore.file?.scraped"
        :selected-header="selectedTableHeader"
      />
    </div>
  </div>
</template>
